import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import HoldingsOverTimeChart from './HoldingsOverTimeChart';

const schema: JSONSchema7 = {
    title: 'Holdings Over Time Chart',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        chartTitles: headingsSchema,
        dataKey: {
            type: 'string',
            title: 'Data key',
            default: '',
        },
        options: {
            type: 'array',
            title: 'Holdings Over Time Chart Options',
            items: {
                type: 'object',
                properties: {
                    path: { type: 'string', description: 'Options Object Path' },
                    value: { type: 'string', description: 'High Chart Options as JSON string' },
                },
            },
        },
        columns: {
            type: 'array',
            title: 'Add Pie Table columns',
            items: {
                type: 'object',
                properties: {
                    label: { type: 'string', description: 'Column header text' },
                    value: { type: 'string', description: 'Coulmn data key' },
                },
            },
        },
        otherText: {
            type: 'string',
            title: 'Other Holding Text',
            default: '',
        },
        isLimitHoldingsToTen: {
            type: 'boolean',
            title: 'Limit Holdings to ten',
            default: true,
        },
        isSortHoldingsTable: {
            type: 'boolean',
            title: 'Sort holdings table alphabetically',
            default: true,
        },
        orderToSortHoldingsTable: {
            type: 'string',
            title: 'Order to sort holdings table',
            default: '',
            description: 'Enter comma seperated values',
        },
        paletteId: {
            type: 'string',
            title: 'Palette ID',
            default: 'pieChartPalette',
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'paletteId',
            'chartTitles',
            'dataKey',
            'options',
            'columns',
            'otherText',
            'isLimitHoldingsToTen',
            'isSortHoldingsTable',
            'orderToSortHoldingsTable',
        ],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    chartTitles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    paletteId: {
        'ui:widget': 'PaletteSelect',
    },
    styles: {
        'ui:widget': 'CSSEditor',
    },
    dataKey: {
        'ui:widget': 'CustomTextInput',
    },
    orderToSortHoldingsTable: {
        'ui:widget': 'CustomTextInput',
    },
    otherText: {
        'ui:widget': 'CustomTextInput',
    },
    options: {
        items: {
            path: {
                'ui:widget': 'CustomTextInput',
            },
            value: {
                'ui:widget': 'CustomTextInput',
            },
        },
    },
    columns: {
        items: {
            label: {
                'ui:widget': 'CustomTextInput',
            },
            value: {
                'ui:widget': 'CustomTextInput',
            },
        },
    },
    isLimitHoldingsToTen: {
        'ui:widget': 'CustomCheckbox',
    },
    isSortHoldingsTable: {
        'ui:widget': 'CustomCheckbox',
    },
};

const HoldingsOverTimeChartWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: HoldingsOverTimeChart,
    id: 'HoldingsOverTimeChart',
    group: 'charts',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default HoldingsOverTimeChartWidget;
